function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6876_5562)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 0.5C2.68661 0.5 0 3.18661 0 6.5C0 9.81339 2.68661 12.5 6 12.5C9.31339 12.5 12 9.81339 12 6.5C12 3.18661 9.31339 0.5 6 0.5ZM6 11.4821C3.24911 11.4821 1.01786 9.25089 1.01786 6.5C1.01786 3.74911 3.24911 1.51786 6 1.51786C8.75089 1.51786 10.9821 3.74911 10.9821 6.5C10.9821 9.25089 8.75089 11.4821 6 11.4821Z",
  fill: "black",
  fillOpacity: 0.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.49492 3.88396C7.09314 3.53172 6.56278 3.33887 6.00028 3.33887C5.43778 3.33887 4.90742 3.53306 4.50564 3.88396C4.08778 4.24958 3.85742 4.7411 3.85742 5.26744V5.36922C3.85742 5.42815 3.90564 5.47637 3.96456 5.47637H4.60742C4.66635 5.47637 4.71456 5.42815 4.71456 5.36922V5.26744C4.71456 4.67681 5.2918 4.19601 6.00028 4.19601C6.70876 4.19601 7.28599 4.67681 7.28599 5.26744C7.28599 5.68396 6.99135 6.06565 6.53465 6.2411C6.25073 6.34958 6.00965 6.53976 5.83689 6.78887C5.66144 7.04333 5.57037 7.34869 5.57037 7.65806V7.94601C5.57037 8.00494 5.61858 8.05315 5.67751 8.05315H6.32037C6.3793 8.05315 6.42751 8.00494 6.42751 7.94601V7.64199C6.4282 7.51198 6.46806 7.38519 6.54188 7.27816C6.6157 7.17113 6.72006 7.08883 6.84135 7.04199C7.63153 6.73798 8.1418 6.04155 8.1418 5.26744C8.14314 4.7411 7.91278 4.24958 7.49492 3.88396ZM5.46456 9.44601C5.46456 9.58809 5.52101 9.72435 5.62147 9.82482C5.72194 9.92528 5.8582 9.98173 6.00028 9.98173C6.14236 9.98173 6.27862 9.92528 6.37909 9.82482C6.47955 9.72435 6.53599 9.58809 6.53599 9.44601C6.53599 9.30393 6.47955 9.16767 6.37909 9.0672C6.27862 8.96674 6.14236 8.9103 6.00028 8.9103C5.8582 8.9103 5.72194 8.96674 5.62147 9.0672C5.52101 9.16767 5.46456 9.30393 5.46456 9.44601Z",
  fill: "black",
  fillOpacity: 0.6
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6876_5562"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white",
  transform: "translate(0 0.5)"
})));

var SvgQuestionCircle = function SvgQuestionCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestionCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/QuestionCircle.098e0ac2.svg";
export { ForwardRef as ReactComponent };